<template>
  <TaskTable />
</template>

<script>
import TaskTable from './components/TaskTable.vue'

export default {
  components: {
    TaskTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
</script>
